// src/components/Qstatus.jsx

import React, { useEffect, useState } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import ReceptionNurseDashboard from "./ReceptionNurseDashboard";
import "./Dashboard.css";

import { API_BASE } from "../apiConfig";

export default function Qstatus() {
  const [open, setOpen] = useState(true);
  const [todayTotal, setTodayTotal] = useState(0);

  /* ============================================================
     SIDEBAR - MOBILE / DESKTOP
  ============================================================ */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* ============================================================
     TODAY TOTAL
  ============================================================ */
  const fetchTodayTotal = async () => {
    try {
      const response = await fetch(
        `${API_BASE}today_total.php`
      );

      const data = await response.json();

      if (data.status) {
        setTodayTotal(data.total || 0);
      }
    } catch (error) {
      console.error("Today total error:", error);
    }
  };

  useEffect(() => {
    fetchTodayTotal();

    const interval = setInterval(() => {
      fetchTodayTotal();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container-fluid p-0">
      {/* ========================================================
          SIDEBAR TOGGLE
      ======================================================== */}
      <div
        className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
        style={{
          zIndex: 999,
          cursor: "pointer",
          position: "fixed",
          left: open ? "350px" : "60px",
          top: "0",
          transition: "left 0.3s ease",
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span
          className="displaysidemenu"
          style={{
            position: "absolute",
            right: "-10px",
          }}
        >
          ☰
        </span>
      </div>

      <div
        className="d-flex"
        style={{ height: "100vh" }}
      >
        {/* ======================================================
            LEFT SIDEBAR
        ====================================================== */}
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease",
          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* ======================================================
            RIGHT CONTENT
        ====================================================== */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddingLeft: "30px",
          }}
        >
          <TopBanner />

          <div className="area">
            <ReceptionNurseDashboard />
          </div>
        </div>
      </div>
    </div>
  );
}
